// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__XDIsR","closeModalIcon":"PopUpModal_closeModalIcon__UsifO"};